module.exports = __webpack_public_path__ + "img/img23.000428f9.svg";